import { Col, Row, Button } from 'react-bootstrap';
import { useState, useEffect, useCallback } from 'react';

import BasicSpinner from '../common/basic-spinner';
import PaginatedList from '../common/pagination';

import { fetchPublicItems } from '../../utils/fetch-helpers'

//================================================================

export default function ItemsPage(){

  const [items, setItems] = useState();

  //----------------------------------------------------------------

  const fetchItems = async (signal) => {
    setItems(await fetchPublicItems(signal));
  }

  //----------------------------------------------------------------

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchItems(signal);

    return () => {
      // Cancel the request when the component unmounts
      abortController.abort();
    };
  }, []);

  //----------------------------------------------------------------

  return(
    <>
      {!items ?
        <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
        :
        <>
          <Row className="mb-2">
            <Col className="h4 text-start">Public Items:</Col>
          </Row>
          <PaginatedList
            key='public-items'
            list={items}
            type='item'
          />
        </>
      }
    </>
  );
}
